import Rails from '@rails/ujs';

export default class StudentsAlertsIndex {
  constructor() {
    this.namespace = '.students-alerts-index';
    this.$document = $(document);
    this.$window = $(globalThis);
    this.$modal = $('#alert-modal');
    this.$modalWrapper = this.$modal.find('[data-alert-modal-wrapper]');
    this.fullscreenClass = 'modal-fullscreen';
    this.fullscreenBreakpoint = 768;

    if (!this.$modal.length || !this.$modalWrapper.length) {
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    this.$document.on('click' + this.namespace, '.js-alert-open', (event) => {
      event.preventDefault();
      const $trigger = $(event.currentTarget);
      const url = $trigger.data('alert-url') || $trigger.attr('href');
      if (!url) {
        return;
      }
      this.loadStep(url, 'GET');
    });
    if (this.$modal.data('display-on-load')) {
      this.loadStep(this.$modal.data('alert-url'), 'GET');
    }

    this.$modal.on('click' + this.namespace, '[data-alert-loading-link]', (event) => {
      event.preventDefault();
      const $link = $(event.currentTarget);
      const url = $link.data('alert-url') || $link.attr('href');
      if (!url) {
        return;
      }
      const method = ($link.data('method') || 'GET').toUpperCase();
      this.loadStep(url, method);
    });

    this.$modal.on('submit' + this.namespace, 'form[data-alert-modal-form]', (event) => {
      event.preventDefault();
      const $form = $(event.currentTarget);
      const url = $form.attr('action');
      const method = ($form.attr('method') || 'POST').toUpperCase();
      this.loadStep(url, method, $form.serialize());
    });

    this.$modal.on('click' + this.namespace, '[data-alert-city-toggle]', (event) => {
      event.preventDefault();
      const $toggle = $(event.currentTarget);
      const $container = $toggle.closest('[data-alert-city]');
      const expanded = $container.hasClass('is-expanded');
      $container.toggleClass('is-expanded', !expanded);
      $toggle.attr('aria-expanded', expanded ? 'false' : 'true');
    });

    this.$modal.on('change' + this.namespace, 'input[data-alert-city-checkbox]', (event) => {
      const $cityInput = $(event.currentTarget);
      this.syncCitySelection($cityInput);
      this.updateConfirmButtons($cityInput.closest('form'));
    });

    this.$modal.on('change' + this.namespace, 'input[data-alert-department-checkbox]', (event) => {
      const $departmentInput = $(event.currentTarget);
      this.syncDepartmentSelection($departmentInput);
      this.updateConfirmButtons($departmentInput.closest('form'));
    });

    this.$modal.on('change' + this.namespace, 'input[name="customer_alert[formula_ids][]"]', (event) => {
      this.updateConfirmButtons($(event.currentTarget).closest('form'));
    });

    this.$modal.on('hidden.bs.modal' + this.namespace, () => {
      this.$modalWrapper.empty();
    });

    this.$modal.on('show.bs.modal' + this.namespace, () => {
      this.updateModalFullscreen();
    });

    this.$window.on('resize' + this.namespace, () => {
      if (this.$modal.hasClass('show')) {
        this.updateModalFullscreen();
      }
    });
  }

  loadStep(url, method = 'GET', data = null) {
    Rails.ajax({
      url,
      type: method,
      data,
      dataType: 'json',
      beforeSend: () => {
        this.showModal();
        this.toggleLoading(true);
        return true;
      },
      success: (response) => {
        if (response.card) {
          $('#student-alert-card').replaceWith(response.card);
        }

        if (response.flash) {
          this.dispatchFlash(response.flash);
        }

        if (response.closeModal) {
          this.$modal.modal('hide');
          return;
        }

        if (response.modal) {
          this.$modalWrapper.html(response.modal);
          this.initializeContent();
        }

        this.showModal();
      },
      error: () => {
        this.dispatchFlash({ error: I18n.t('students.alerts.modal.errors.generic') });
      },
      complete: () => {
        this.toggleLoading(false);
      }
    });
  }

  showModal() {
    if (!this.$modal.hasClass('show')) {
      this.updateModalFullscreen();
      this.$modal.modal('show');
    }
  }

  toggleLoading(state) {
    this.$modal.toggleClass('is-loading', state);
  }

  initializeContent() {
    this.$modal.find('input[data-alert-city-checkbox]').each((_, element) => {
      const $input = $(element);
      const indeterminate = $input.data('indeterminate');
      $input.prop('indeterminate', Boolean(indeterminate));
    });

    this.$modal.find('form[data-alert-modal-form]').each((_, form) => {
      this.updateConfirmButtons($(form));
    });
  }

  syncCitySelection($cityInput) {
    const cityId = $cityInput.data('city-id');
    const checked = $cityInput.is(':checked');
    const selector = `input[data-alert-department-checkbox][data-city-id="${cityId}"]`;
    const $departments = this.$modal.find(selector);

    $departments.prop('checked', checked);
    $cityInput.prop('indeterminate', false);
  }

  syncDepartmentSelection($departmentInput) {
    const cityId = $departmentInput.data('city-id');
    if (cityId === undefined || cityId === null) {
      return;
    }

    const selector = `input[data-alert-department-checkbox][data-city-id="${cityId}"]`;
    const $departments = this.$modal.find(selector);
    const $cityInput = this.$modal.find(`input[data-alert-city-checkbox][data-city-id="${cityId}"]`);

    if (!$cityInput.length) {
      return;
    }

    const total = $departments.length;
    const checked = $departments.filter(':checked').length;

    if (checked === 0) {
      $cityInput.prop({ checked: false, indeterminate: false });
    } else if (checked === total) {
      $cityInput.prop({ checked: true, indeterminate: false });
    } else {
      $cityInput.prop({ checked: false, indeterminate: true });
    }
  }

  updateConfirmButtons($form) {
    if (!$form || !$form.length) {
      return;
    }

    const $button = $form.find('[data-alert-confirm-button]');
    if (!$button.length) {
      return;
    }

    let selector = 'input[name="customer_alert[department_ids][]"]:checked';

    if ($form.find('input[name="customer_alert[formula_ids][]"]').length) {
      selector = 'input[name="customer_alert[formula_ids][]"]:checked';
    }

    const count = $form.find(selector).length;

    const template = $button.data('label-template');
    let label = $button.text();

    if (template && template.indexOf('%{count}') !== -1) {
      label = template.replace('%{count}', count);
    } else if (template) {
      label = template;
    }

    $button.text(label);
    $button.prop('disabled', count === 0);
  }

  dispatchFlash(flash) {
    Object.entries(flash || {}).forEach(([type, message]) => {
      globalThis.dispatchEvent(new CustomEvent('flash:message', { detail: { type, message } }));
    });
  }

  updateModalFullscreen() {
    const $dialog = this.$modal.find('.modal-dialog');
    if (!$dialog.length) {
      return;
    }

    const isMobile = globalThis.innerWidth < this.fullscreenBreakpoint;
    $dialog.toggleClass(this.fullscreenClass, isMobile);
  }

  onDestroy() {
    this.$document.off(this.namespace);
    this.$modal.off(this.namespace);
    this.$window.off(this.namespace);
  }
}
